// src/hooks/hotelMealPlans/useDeleteHotelMealPlan.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteHotelMealPlan } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useDeleteHotelMealPlan = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteHotelMealPlans, isPending: isDelete } = useMutation({
        mutationFn: deleteHotelMealPlan,
        onSuccess: (res) => {
            const message = res?.message || "Hotel meal plan deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete hotel meal plan");
        },
    });

    return { deleteHotelMealPlans, isDelete };
};

export default useDeleteHotelMealPlan;
